import notifications from './notifications';
import plugins from './plugins';

export default {
  notifications,
  plugins,
};
